import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'
import moment from "moment"

// axios API default
axios.defaults.baseURL = "https://yliflood.yunlin.gov.tw/api"
//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//Setup moment
moment.locale('zh_tw')

// proj4
let bootstrapSetting = {
  BModal: {
    "titleTag": "h5",
    "size": "md",
    "headerBgVariant": null,
    "headerBorderVariant": null,
    "headerTextVariant": null,
    "headerCloseVariant": null,
    "bodyBgVariant": null,
    "bodyTextVariant": null,
    "footerBgVariant": null,
    "footerBorderVariant": null,
    "footerTextVariant": null,
    "cancelTitle": "取消",
    "cancelVariant": "secondary",
    "okTitle": "確認",
    "okVariant": "primary",
    "headerCloseContent": "&times;",
    "headerCloseLabel": "關閉"
  }
}

Vue.config.productionTip = false
Vue.use(BootstrapVue, bootstrapSetting)
Vue.use(BootstrapVueIcons)

new Vue({
  render: h => h(App)
}).$mount('#app')
